export enum ContentType {
	PDF = 'pdf',
	Excel = 'excel',
	Word = 'word',
	Jpeg = 'jpeg',
	Other = 'other'
}

export function getContentType(contentType: string): ContentType {
	switch (contentType) {
		case 'application/pdf':
			return ContentType.PDF;
		case 'application/msword':
			return ContentType.Word;
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			return ContentType.Word;
		case 'application/vnd.ms-excel':
			return ContentType.Excel;
		case 'text/csv':
			return ContentType.Excel;
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			return ContentType.Excel;
		case 'image/jpeg':
			return ContentType.Jpeg;
		default: return ContentType.Other;
	}
}

